import { useQuery } from '@tanstack/react-query';

import { PRICING_SIMULATION_CONTEXT, PricingSimulation } from 'src/features/pricingPlan/utils/types';
import { VISITOR_TYPE } from 'src/features/visitor/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/pricing/pricing-plan/:planId/simulate-pricing/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    planId: string;
    // Both ISO - the period of the simulated stay
    start: string;
    end: string;
    // Where the stay is simulated - without an object the tariff itself is
    context_type?: PRICING_SIMULATION_CONTEXT;
    context_id?: string;
    // The type of the simulated visitor - it picks between the assignments of the object
    visitor_type?: VISITOR_TYPE;
}

const queryFn = ({ parkingId, planId, ...params }: DTO): Promise<PricingSimulation> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, planId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}

const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as SIMULATE_PRICING_PLAN_RESOURCE, useQueryHook as useSimulatePricingPlan };
